import { BonusStatus } from '@my-account/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const getBonusStatusState: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<BonusStatus>
> = createSelector(getMyAccountState, (state: MyAccountState) => state.bonusStatus);

export const getBonusStatusValue: MemoizedSelector<StateWithMyAccount, BonusStatus> = createSelector(
  getBonusStatusState,
  (state) => StateUtils.loaderValueSelector(state),
);
